import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/reconcile-report',
    name: 'reconcile-report',
    component: () => import('./pages/ReconcileReportPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'admin',
    },
  },
];
